import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import Reveal from "@/components/Reveal";
import { useContent } from "@/lib/content-context";

const HERO = "https://images.unsplash.com/photo-1559348349-86f1f65817fe?auto=format&fit=crop&w=1800&q=80";

export default function ServicesPage() {
  const { services } = useContent();
  return (
    <div data-testid="services-page">
      <section className="relative h-[60vh] min-h-[420px] -mt-24 flex items-end overflow-hidden">
        <img src={HERO} alt="Airline operations" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-midnight to-midnight/30" />
        <div className="relative container-edge pb-14 text-linen">
          <div className="overline text-ochre mb-4">Airline representation</div>
          <h1 className="editorial-h1 max-w-3xl">Our service lines.</h1>
        </div>
      </section>

      <section className="section-pad bg-linen">
        <div className="container-edge">
          <SectionHeading
            overline="Nine dedicated services"
            title="A complete airline representation operation."
            lede="From regulatory accreditation and BSP settlement, to a UK-based contact centre and tactical fare campaigns — every component of a modern GSA, delivered under one roof."
          />

          <div className="mt-16 space-y-px bg-ink/10 border border-ink/10">
            {services.map((s, i) => (
              <Reveal
                key={s.slug}
                className="bg-linen p-10 md:p-14 grid grid-cols-1 md:grid-cols-12 gap-6 items-start group"
                data-testid={`service-row-${s.slug}`}
              >
                <div className="md:col-span-1 font-serif text-3xl text-terracotta">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="md:col-span-4">
                  <h3 className="editorial-h3">{s.name}</h3>
                </div>
                <div className="md:col-span-5">
                  <p className="text-base text-muted2 leading-relaxed">{s.short}</p>
                </div>
                <div className="md:col-span-2 md:text-right">
                  <Link
                    to={`/services/${s.slug}`}
                    className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase border-b border-ink/30 pb-1 group-hover:text-terracotta group-hover:border-terracotta transition-colors"
                  >
                    Read more <ArrowRight className="w-3 h-3" />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
